import React, { useEffect } from 'react'
import { Badge, Container, Row } from 'react-bootstrap';
import FormSignatureData from './FormSignatureData';
import FormDataEntrySignature from '../DataEntryManagement/FormDataEntrySignature';
import FormFieldList from './FormFieldList';
import FormMedicalReviewData from './FormMedicalReviewData';

const FormReport = ({
    repeatConditionalButtonLoader,
    repeatStudySubjectEventConditinalForm,
    connectedFormFieldList,
    connectedFormFieldLoader,
    handleAddNewTab,
    activeTabName,
    formFields,
    formType,
    totalOptionId,
    setErrorValidation,
    valueRanderFunction,
    handleNumberChange,
    handleCustomNumberChange,
    handleTextChange,
    handleCustomTextChange,
    handleDateChange,
    handleCustomDateChange,
    handleTimeChange,
    handleCustomTimeChange,
    handleTextareaChange,
    handleDropdownRadioChange,
    handleCustomDropdownRadioChange,
    handleRangeScoreChange,
    fileUploadLoader,
    handleUploadChange,
    handleScaleChange,
    handleCheckboxChange,
    handleCustomCheckboxChange,
    convertTo24,
    setToggle,
    DBPSignatureBy,
    DBPQualityCheck,
    DBPSignatureDT,
    DBPSignatureCode,
    DVSignatureCode,
    DVQualityCheck,
    DVSignatureBy,
    DVSignatureDT,
    footer,
    enableDataEntry,
    setFieldId,
    setFieldLabel,
    setToggle3,
    setToggle5,
    getStudySubjectFormFreezeUnfreezeHistoryDataEntry,
    getStudySubjectFormFieldReviewHistoryDataEntry,
    getStudyDataEntryFieldUpdatedHistoryList,
    studyPermission,
    dataEntryFormReviewHistory,
    dataEntryFormReviewHistoryLoader,
    getStudySubjectFormReviewDataEntryList,
    formId,
    version,
    entryType,
    setToggle6,
    emptyDataEntry,
    editField,
    recordId,
    handleCheckboxEditFieldChange,
}) => {
    const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

    useEffect(() => {
        let hasError = false;
        formFields?.forEach(field => {
            const value = Number(valueRanderFunction(field.id)?.value);
            if (field?.manageRange === "yes") {
                if (value < Number(field?.minRange) || value > Number(field?.maxRange)) {
                    hasError = true;
                }
            }
            if (field?.manageScore === "yes") {
                if (value < Number(field?.minScore) || value > Number(field?.maxScore)) {
                    hasError = true;
                }
            }
            if (field?.manageNumberRange === "yes") {
                if (value < Number(field?.minNumber) || value > Number(field?.maxNumber)) {
                    hasError = true;
                }
            }
            if (field?.manageTimeRange === "yes") {
                const hour = valueRanderFunction(field.id)?.hour?.padStart(2, '0') || "00"
                const minute = valueRanderFunction(field.id)?.minute?.padStart(2, '0') || "00"
                const second = valueRanderFunction(field.id)?.second?.padStart(2, '0') || "00"
                const format = valueRanderFunction(field.id)?.format?.toUpperCase() || "AM"
                const use12Hour = field?.clockTimeFormat === "12";
                const inputTimeStr = use12Hour
                    ? `${hour}:${minute}:${second} ${format}`
                    : `${hour}:${minute}:${second}`;

                const minTimeStr = use12Hour
                    ? `${field?.minTime || "12:00:00"} ${field?.minAmpmType?.toUpperCase() || "AM"}`
                    : `${field?.minTime || "00:00:00"}`;

                const maxTimeStr = use12Hour
                    ? `${field?.maxTime || "11:59:59"} ${field?.maxAmpmType?.toUpperCase() || "PM"}`
                    : `${field?.maxTime || "23:59:59"}`;

                const inputDate = new Date(`1970-01-01T${use12Hour ? convertTo24(inputTimeStr) : inputTimeStr}`);
                const minDate = new Date(`1970-01-01T${use12Hour ? convertTo24(minTimeStr) : minTimeStr}`);
                const maxDate = new Date(`1970-01-01T${use12Hour ? convertTo24(maxTimeStr) : maxTimeStr}`);
                if (inputDate >= minDate || inputDate <= maxDate) {
                    hasError = true;
                }
            }
            if (field?.manageDateRange === "yes") {
                const year = valueRanderFunction(field.id)?.year
                const month = valueRanderFunction(field.id)?.month
                const day = valueRanderFunction(field.id)?.day
                const inputDate = new Date(`${year}-${month}-${day}`);
                const minDate = new Date(valueRanderFunction(field.id)?.minDate);
                const maxDate = new Date(valueRanderFunction(field.id)?.minDate);
                if (inputDate >= minDate || inputDate <= maxDate) {
                    hasError = true;
                }
            }
        });
        setErrorValidation(hasError);
    }, [formFields, valueRanderFunction]);

    return (
        <>
            <Container fluid>
                <Row>
                    {connectedFormFieldList?.length > 0 &&
                        <div className='d-block mb-2'>
                            {connectedFormFieldLoader ?
                                <Badge
                                    bg={"secondary-subtle"}
                                    className={`br3 w-100 mt-2 text-secondary text-start`}
                                    style={{ fontSize: 12 }}
                                >
                                    <span className='text-dark'>
                                        Loading
                                        <div style={{ width: 8, height: 8, marginLeft: 2 }} className="spinner-grow" />
                                        <div style={{ width: 8, height: 8, marginLeft: 2 }} className="spinner-grow" />
                                        <div style={{ width: 8, height: 8, marginLeft: 2 }} className="spinner-grow" />
                                    </span>
                                </Badge>
                                :
                                connectedFormFieldList?.map((item, index) => (
                                    <Badge
                                        key={index}
                                        bg={"secondary-subtle"}
                                        className={`br3 w-100 mt-2 text-secondary text-start`}
                                        style={{ fontSize: 12 }}
                                    >
                                        <span className='text-dark'> Connected Form Field : {" "}</span>
                                        {`Site: ${activeTabName?.siteName || ""}` +
                                            ` > Subject: ${activeTabName?.subjectName || ""}` +
                                            ` > Event: ${item?.eventName}` +
                                            (item?.timePointId
                                                ? ` (${item?.timePointId})`
                                                : "") +
                                            ` > Form: ${item?.formName || ""} (v${item?.formVersion || "1"})` +
                                            ` > Field: ${item?.fieldName || ""}` +
                                            ` > Option: ${item?.optionName || ""}`
                                        }
                                    </Badge>
                                ))}
                        </div>
                    }
                    {formFields?.map((field, index) => (
                        (field?.conditionalIds || [])?.every(id => totalOptionId?.includes(id)) &&
                        <div key={field?.id}>
                            <FormFieldList
                                repeatConditionalButtonLoader={repeatConditionalButtonLoader}
                                repeatStudySubjectEventConditinalForm={repeatStudySubjectEventConditinalForm}
                                activeTabName={activeTabName}
                                handleAddNewTab={handleAddNewTab}
                                formType={formType}
                                recordId={recordId}
                                field={field}
                                convertTo24={convertTo24}
                                StudyMode={StudyMode}
                                studyPermission={studyPermission}
                                valueRanderFunction={valueRanderFunction}
                                handleNumberChange={handleNumberChange}
                                handleCustomNumberChange={handleCustomNumberChange}
                                handleTextChange={handleTextChange}
                                handleCustomTextChange={handleCustomTextChange}
                                handleDateChange={handleDateChange}
                                handleCustomDateChange={handleCustomDateChange}
                                handleTimeChange={handleTimeChange}
                                handleCustomTimeChange={handleCustomTimeChange}
                                handleTextareaChange={handleTextareaChange}
                                handleDropdownRadioChange={handleDropdownRadioChange}
                                handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
                                handleRangeScoreChange={handleRangeScoreChange}
                                fileUploadLoader={fileUploadLoader}
                                handleUploadChange={handleUploadChange}
                                handleScaleChange={handleScaleChange}
                                handleCheckboxChange={handleCheckboxChange}
                                handleCustomCheckboxChange={handleCustomCheckboxChange}
                                enableDataEntry={enableDataEntry}
                                setFieldId={setFieldId}
                                setFieldLabel={setFieldLabel}
                                setToggle3={setToggle3}
                                setToggle5={setToggle5}
                                getStudySubjectFormFreezeUnfreezeHistoryDataEntry={getStudySubjectFormFreezeUnfreezeHistoryDataEntry}
                                getStudySubjectFormFieldReviewHistoryDataEntry={getStudySubjectFormFieldReviewHistoryDataEntry}
                                getStudyDataEntryFieldUpdatedHistoryList={getStudyDataEntryFieldUpdatedHistoryList}
                                handleCheckboxEditFieldChange={handleCheckboxEditFieldChange}
                                editField={editField}
                                targetFormId={formId}
                                targetFormVersion={version}
                                entryType={entryType}
                            />
                        </div>
                    ))}
                    <FormSignatureData
                        setToggle={setToggle}
                        DBPSignatureBy={DBPSignatureBy}
                        DBPQualityCheck={DBPQualityCheck}
                        DBPSignatureDT={DBPSignatureDT}
                        DBPSignatureCode={DBPSignatureCode}
                        DVSignatureCode={DVSignatureCode}
                        DVQualityCheck={DVQualityCheck}
                        DVSignatureBy={DVSignatureBy}
                        DVSignatureDT={DVSignatureDT}
                        footer={footer}
                    />
                    <FormMedicalReviewData
                        formId={formId}
                    />
                    {getStudySubjectFormReviewDataEntryList && !emptyDataEntry && (studyPermission?.liveViewFormSignature || studyPermission?.liveSDVFormSignature || studyPermission?.qcViewFormSignature || studyPermission?.qcSDVFormSignature || StudyMode === "DBP Mode") &&
                        <FormDataEntrySignature
                            emptyDataEntry={emptyDataEntry}
                            dataEntryFormReviewHistory={dataEntryFormReviewHistory}
                            getStudySubjectFormReviewDataEntryList={getStudySubjectFormReviewDataEntryList}
                            formId={formId}
                            StudyMode={StudyMode}
                            setToggle6={setToggle6}
                            dataEntryFormReviewHistoryLoader={dataEntryFormReviewHistoryLoader}
                        />
                    }
                </Row>
            </Container>
        </>
    )
}

export default FormReport